import '../css/style.css';
import Slider from './imageSlider';

const slider = new Slider();
